import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Container,
  Form,
  RequiredField,
  WarningInputMessage,
} from "../../styles/GlobalStyles";
import {
  Content,
  CardHeader,
  CardTitle,
  CategoryTitle,
  InputContainer,
  CustomButton,
  FormSection,
  CourseDiv,
  InputContainerCourse,
  InputContainerYear,
  DisabledCustomButton,
  TermsText,
  LinkText,
} from "./styled";
import { Checkbox, MenuItem, Select } from "@mui/material";

import api from "../../api/axios";

import { useDispatch } from "react-redux";
import * as actions from "../../store/modules/auth/actions";

import { BRAZILIAN_STATES } from "../../constants/brazilianStates";
import { ACADEMIC_LIST } from "../../constants/academic";
import ReactInputMask from "react-input-mask";
import WhatsappButton from "../../components/WhatsappButton";
import { toast } from "react-toastify";
import { validarCPF } from "../../utils/validarCPF";

export default function Register() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [userData, setUserData] = useState({
    username: "",
    email: "",
    password: "",
  });
  const [personalData, setPersonalData] = useState({
    name: "",
    cpf: "",
    phone: "",
    address: "",
  });
  const [address, setAddress] = useState({
    street: "",
    number: "",
    city: "",
    state: "",
    district: "",
    cep: "",
    additional: "",
  });
  const [academicData, setAcademicData] = useState({
    educationLevel: "",
    course: "",
    year: "",
    local: "",
  });

  const [unlockDistrict, setUnlockDistrict] = useState(false);
  const [unlockStreet, setUnlockStreet] = useState(false);

  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSendingForm, setIsSendingForm] = useState(false);
  const [agreedTerms, setAgreedTerms] = useState(false);

  const [error, setError] = useState("");

  const validateFields = () => {
    const errors = [];

    if (userData.password !== confirmPassword) {
      errors.push("As senhas não coincidem.");
    }

    if (
      userData.password > 0 &&
      (String(userData.password).length < 8 ||
        String(userData.password).length > 20)
    ) {
      errors.push("A senha deve ter de 8 e 20 caracteres.");
    }

    if (
      personalData.cpf &&
      (personalData.cpf.length !== 14 || !validarCPF(personalData.cpf))
    ) {
      errors.push("CPF inválido.");
    }

    if (personalData.phone.length !== 15) {
      errors.push("Telefone inválido.");
    }

    if (
      (address.cep && address.cep.length !== 9) ||
      (address.cep && !address.street)
    ) {
      errors.push("CEP inválido.");
    }

    if (address.street && !address.number) {
      errors.push("O número é obrigatório");
    }

    return errors.length === 0;
  };

  const isFormComplete = () => {
    // const academicDataClone =
    //   academicData.educationLevel === "Ensino Superior completo"
    //     ? academicData
    //     : { educationLevel: academicData.educationLevel };

    const allFields = {
      ...userData,
      name: personalData.name,
      // cpf: personalData.cpf,
      phone: personalData.phone,
      // ...address,
      // ...academicDataClone,
    };

    if (allFields["additional"] === "") delete allFields["additional"];

    return Object.values(allFields).every((value) => value.trim() !== "");
  };

  const availableEmail = async () => {
    let status;

    await api
      .post("/user/verify-email", { email: userData.email })
      .then((res) => (status = res.data.status))
      .catch((err) => toast.error(err));
    return status;
  };

  const availableCpf = async () => {
    let status;

    await api
      .post("/professional/verify-cpf", { cpf: personalData.cpf })
      .then((res) => (status = res.data.status))
      .catch((err) => toast.error(err));
    return status;
  };

  const availableUsername = async () => {
    let status;

    await api
      .post("/user/verify-username", { username: userData.username })
      .then((res) => (status = res.data.status))
      .catch((err) => toast.error(err));
    return status;
  };

  const formValidation = async () => {
    if (!agreedTerms) {
      setError("Para se inscrever, é necessário concordar com os termos");
      return false;
    }

    if (!isFormComplete()) {
      setError("Por favor, preencha todos os campos");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(userData.email)) {
      setError("Por favor, insira um e-mail válido");
      return false;
    }

    if (userData.password.length < 8 || userData.password.length > 20) {
      setError("A senha deve ter de 8 e 20 caracteres");
      return false;
    }

    const isUsernameAvailable = await availableUsername();
    if (!isUsernameAvailable) {
      setError("Este nome de usuário já está cadastrado");
      return false;
    }

    const isEmailAvailable = await availableEmail();
    if (!isEmailAvailable) {
      setError("Este email já está cadastrado");
      return false;
    }

    if (personalData.cpf) {
      const isCpfAvailable = await availableCpf();
      if (!isCpfAvailable) {
        setError("Este CPF já está cadastrado");
        return false;
      }
    }

    const isFieldsValid = validateFields();
    if (!isFieldsValid) {
      setError("Por favor, verifique os campos novamente");
      return false;
    }

    return true;
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setIsSendingForm(true);

    const isFormValid = await formValidation();
    if (!isFormValid) {
      setIsSendingForm(false);
      return;
    }

    const professional = {
      ...personalData,
      address: {
        ...address,
        street: `${address.street}, ${address.number}`,
      },
      academicLevel: academicData,
    };

    delete professional.address.number;

    const fileRes = await api.post("/file/get-latest", {
      name: "Termos",
    });

    try {
      await api.post("/user/create", {
        user: userData,
        professional,
        fileAgreedAt: fileRes.data.latest._id,
      });

      const { email, password } = userData;

      dispatch(
        actions.loginRequest({
          email,
          password,
        }),
      );
    } catch (err) {
      toast.error(err);
      setError("Erro desconhecido");
    }

    navigate("/perfil");
  }

  const handleBackButtonClick = () => {
    navigate("/");
  };

  const handleEducationLevelChange = (e) => {
    setAcademicData({
      educationLevel: e.target.value,
      course:
        academicData.educationLevel === "Ensino superior completo"
          ? academicData.course
          : "",
      year:
        academicData.educationLevel === "Ensino superior completo"
          ? academicData.year
          : "",
    });
  };

  const handleTermClick = async () => {
    try {
      const res = await api.post("/file/get-signed-url", {
        name: "Termos",
      });
      if (res.status === 200) {
        window.open(res.data.signedUrl, "_blank");
      } else {
        toast.error("Ocorreu um erro");
      }
    } catch (err) {
      toast.error("Ocorreu um erro");
      console.log(err);
    }
  };

  useEffect(() => {
    setError("");
  }, [userData, personalData, address, academicData]);

  return (
    <Content>
      <WhatsappButton />
      <Container>
        <CardHeader>
          <a href="https://ticoopbrasil.coop.br/oportunidades-ti/">
            <img
              src="https://ticoopbrasil.coop.br/wp-content/uploads/2020/12/logo-ticoop-cor.png.webp"
              alt="Logo Ticoop"
            />
          </a>
          <CardTitle>
            Faça seu cadastro
            <br />
            GRATUITO
          </CardTitle>
          <CustomButton onClick={handleBackButtonClick}>
            Voltar ao site
          </CustomButton>
        </CardHeader>
        <Form>
          <FormSection>
            <InputContainer>
              {/* Username */}
              <label for="username">
                Nome de usuário:
                <RequiredField title="Campo obrigatório">*</RequiredField>
              </label>
              <input
                id="username"
                name="username"
                type="text"
                value={userData.username}
                onChange={(e) =>
                  setUserData({ ...userData, username: e.target.value })
                }
              />
            </InputContainer>
            <InputContainer>
              {/* E-mail */}
              <label for="email">
                E-mail:
                <RequiredField title="Campo obrigatório">*</RequiredField>
              </label>
              <input
                id="email"
                name="email"
                type="email"
                value={userData.email}
                onChange={(e) =>
                  setUserData({
                    ...userData,
                    email: e.target.value.toLocaleLowerCase(),
                  })
                }
              />
              {userData.email.length > 0 &&
              !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.email) ? (
                <WarningInputMessage>
                  Insira um e-mail válido.
                </WarningInputMessage>
              ) : (
                <></>
              )}
            </InputContainer>
            <InputContainer>
              {/* Password */}
              <label for="password">
                Senha:
                <RequiredField title="Campo obrigatório">*</RequiredField>
              </label>
              <input
                id="password"
                name="password"
                type="password"
                value={userData.password}
                onChange={(e) =>
                  setUserData({ ...userData, password: e.target.value })
                }
              />
              {userData.password !== confirmPassword ? (
                <WarningInputMessage>
                  As senhas não coincidem.
                </WarningInputMessage>
              ) : userData.password > 0 &&
                (String(userData.password).length < 8 ||
                  String(userData.password).length > 20) ? (
                <WarningInputMessage>
                  A senha deve ter de 8 até 20 caracteres.
                </WarningInputMessage>
              ) : (
                <></>
              )}
            </InputContainer>
            <InputContainer>
              {/* Confirm Password */}
              <label for="confirm-password">
                Confirme sua Senha:
                <RequiredField title="Campo obrigatório">*</RequiredField>
              </label>
              <input
                id="confirm-password"
                name="confirm-password"
                type="password"
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                }}
              />
              {userData.password !== confirmPassword ? (
                <WarningInputMessage>
                  As senha não coincidem.
                </WarningInputMessage>
              ) : (
                <></>
              )}
            </InputContainer>
          </FormSection>
          <FormSection>
            <CategoryTitle>Dados Pessoais</CategoryTitle>
            <InputContainer>
              {/* Full name */}
              <label for="name">
                Nome Completo:
                <RequiredField title="Campo obrigatório">*</RequiredField>
              </label>
              <input
                id="name"
                name="name"
                type="text"
                value={personalData.name}
                onChange={(e) =>
                  setPersonalData({ ...personalData, name: e.target.value })
                }
              />
            </InputContainer>
            <InputContainer>
              {/* CPF */}
              <label for="cpf">CPF:</label>
              <ReactInputMask
                mask={"999.999.999-99"}
                maskChar={null}
                value={personalData.cpf}
                onChange={(e) => {
                  setPersonalData({ ...personalData, cpf: e.target.value });
                }}
              >
                {(inputProps) => (
                  <input {...inputProps} id="cpf" name="cpf" type="text" />
                )}
              </ReactInputMask>
              {personalData.cpf !== "" &&
              (personalData.cpf.length !== 14 ||
                !validarCPF(personalData.cpf)) ? (
                <WarningInputMessage>Insira um CPF válido.</WarningInputMessage>
              ) : (
                <></>
              )}
            </InputContainer>
            <InputContainer>
              {/* Phone */}
              <label for="phone">
                Telefone:
                <RequiredField title="Campo obrigatório">*</RequiredField>
              </label>
              <ReactInputMask
                mask={"(99) 99999-9999"}
                maskChar={null}
                value={personalData.phone}
                onChange={(e) =>
                  setPersonalData({ ...personalData, phone: e.target.value })
                }
              >
                {(inputProps) => (
                  <input {...inputProps} id="phone" name="phone" type="text" />
                )}
              </ReactInputMask>
              {personalData.phone.length !== 15 && personalData.phone !== "" ? (
                <WarningInputMessage>
                  Insira um número válido.
                </WarningInputMessage>
              ) : (
                <></>
              )}
            </InputContainer>
            <InputContainer>
              {/* CEP */}
              <label for="cep">CEP:</label>
              <ReactInputMask
                mask={"99999-999"}
                maskChar={null}
                value={address.cep}
                onChange={(e) => {
                  setAddress({ ...address, cep: e.target.value });
                }}
                onBlur={async () => {
                  const cepSemHifen = address.cep.replace("-", "");

                  if (cepSemHifen.length === 8) {
                    try {
                      const response = await api.get(
                        `https://viacep.com.br/ws/${cepSemHifen}/json`,
                      );

                      if (response.data && !response.data.erro) {
                        if (!response.data.bairro) {
                          setUnlockDistrict(true);
                        } else {
                          setUnlockDistrict(false);
                        }
                        if (!response.data.logradouro) {
                          setUnlockStreet(true);
                        } else {
                          setUnlockStreet(false);
                        }

                        setAddress({
                          ...address,
                          street: response.data.logradouro || "",
                          district: response.data.bairro || "",
                          city: response.data.localidade || "",
                          state: response.data.estado || "",
                          cep: address.cep,
                        });
                      } else {
                        setAddress({
                          ...address,
                          street: "",
                          district: "",
                          city: "",
                          state: "",
                        });
                      }
                    } catch (error) {
                      setAddress({
                        ...address,
                        street: "",
                        district: "",
                        city: "",
                        state: "",
                      });
                    }
                  }
                }}
              >
                {(inputProps) => (
                  <input {...inputProps} id="cep" name="cep" type="text" />
                )}
              </ReactInputMask>
              {(address.cep.length === 9 && !address.street && !address.city) ||
              (address.cep !== "" && address.cep.length !== 9) ? (
                <WarningInputMessage>Insira um CEP válido.</WarningInputMessage>
              ) : null}
            </InputContainer>
            <CourseDiv>
              <InputContainerCourse>
                {/* Address */}
                <label for="street">Rua:</label>
                <input
                  id="street"
                  name="street"
                  type="text"
                  value={address.street}
                  disabled={!unlockStreet}
                  onChange={(e) =>
                    setAddress({
                      ...address,
                      street: e.target.value,
                    })
                  }
                />
              </InputContainerCourse>
              <InputContainerYear>
                <label for="number">
                  Número:{" "}
                  {address.street && (
                    <RequiredField title="Campo obrigatório">*</RequiredField>
                  )}
                </label>
                <input
                  id="number"
                  name="number"
                  type="text"
                  value={address.number}
                  onChange={(e) =>
                    setAddress({
                      ...address,
                      number: e.target.value,
                    })
                  }
                />
              </InputContainerYear>
            </CourseDiv>
            <InputContainer>
              {/* City */}
              <label for="city">Cidade:</label>
              <input
                id="city"
                name="city"
                type="text"
                value={address.city}
                disabled
              />
            </InputContainer>
            <InputContainer>
              <label for="state">Estado:</label>
              <Select
                id="state"
                name="state"
                value={address.state}
                sx={{
                  backgroundColor: "#FFF",
                  height: "50px",
                  textAlign: "start",
                  fontSize: "0.9rem",
                }}
                disabled
              >
                {BRAZILIAN_STATES.map((state) => (
                  <MenuItem value={state}>{state}</MenuItem>
                ))}
              </Select>
            </InputContainer>
            <InputContainer>
              {/* District */}
              <label for="district">Bairro:</label>
              <input
                id="district"
                name="district"
                type="text"
                value={address.district}
                disabled={!unlockDistrict}
                onChange={(e) =>
                  setAddress({
                    ...address,
                    district: e.target.value,
                  })
                }
              />
            </InputContainer>
            <InputContainer>
              {/* Additional Info */}
              <label for="additional">Complemento:</label>
              <input
                id="additional"
                name="additional"
                type="text"
                value={address.additional}
                onChange={(e) =>
                  setAddress({
                    ...address,
                    additional: e.target.value,
                  })
                }
              />
            </InputContainer>
          </FormSection>
          <FormSection>
            <CategoryTitle>Informações Acadêmicas</CategoryTitle>
            <InputContainer>
              <label for="education-level">Escolaridade:</label>
              <Select
                id="education-level"
                name="education-level"
                value={academicData.educationLevel}
                onChange={(e) => handleEducationLevelChange(e)}
                sx={{
                  backgroundColor: "#FFF",
                  height: "50px",
                  textAlign: "start",
                  fontSize: "0.9rem",
                }}
              >
                {ACADEMIC_LIST.map((item) => (
                  <MenuItem value={item}>{item}</MenuItem>
                ))}
              </Select>
            </InputContainer>
            {academicData.educationLevel &&
            !academicData.educationLevel.includes("Ensino Médio") ? (
              <>
                <InputContainer>
                  <label for="local">
                    Local:
                    <RequiredField title="Campo obrigatório">*</RequiredField>
                  </label>
                  <input
                    id="local"
                    name="local"
                    type="text"
                    value={academicData.local}
                    onChange={(e) =>
                      setAcademicData({
                        ...academicData,
                        local: e.target.value,
                      })
                    }
                  />
                </InputContainer>
                <CourseDiv>
                  <InputContainerCourse>
                    <label for="course">
                      Curso:
                      <RequiredField title="Campo obrigatório">*</RequiredField>
                    </label>
                    <input
                      id="course"
                      name="course"
                      type="text"
                      value={academicData.course}
                      onChange={(e) =>
                        setAcademicData({
                          ...academicData,
                          course: e.target.value,
                        })
                      }
                    />
                  </InputContainerCourse>
                  <InputContainerYear>
                    <label for="year">
                      Ano:
                      <RequiredField title="Campo obrigatório">*</RequiredField>
                    </label>
                    <input
                      id="year"
                      name="year"
                      type="text"
                      value={academicData.year}
                      onChange={(e) =>
                        setAcademicData({
                          ...academicData,
                          year: e.target.value,
                        })
                      }
                    />
                  </InputContainerYear>
                </CourseDiv>
              </>
            ) : (
              <></>
            )}
          </FormSection>
          <div className="erro">{error}</div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Checkbox
              value={agreedTerms}
              onChange={() => {
                setError("");
                setAgreedTerms(!agreedTerms);
              }}
            />
            <div>
              <TermsText>
                Ao me inscrever, concordo com os{" "}
                <LinkText onClick={handleTermClick}>
                  Termos e Condições
                </LinkText>{" "}
                do site
              </TermsText>
            </div>
          </div>
          {isSendingForm ? (
            <DisabledCustomButton onClick={(e) => e.preventDefault()}>
              Cadastrar
            </DisabledCustomButton>
          ) : (
            <CustomButton type="submit" onClick={handleSubmit}>
              Cadastrar
            </CustomButton>
          )}
        </Form>
      </Container>
    </Content>
  );
}
